<template>
    <div class="collate-form">
        <!-- 公共表单部分 -->
        <!-- 输入姓名 -->
        <div class="collate-form-box collate-form-box-name">
            <input class="collate-form-input collate-form-input-name" type="text" maxlength="50" placeholder="请输入姓名" @input='changeName' @blur='blurInputName' v-model="formData.f_name" autofocus>
        </div>
        <!-- 选择性别+起盘方式 -->
        <div class="collate-form-box collate-form-box-menu dsp-flex">
            <div class="collate-form-inner-box1">
                <div class="collate-form-sub-menu dsp-flex">
                    <span class="collate-form-sub-menu-item item1" :class="formData.sex == 0 ? 'cur' : ''" @click="selectSex(0)">男</span>
                    <span class="collate-form-sub-menu-item item1" :class="formData.sex == 1 ? 'cur' : ''" @click="selectSex(1)">女</span>
                </div>
            </div>
            <div class="collate-form-inner-box2"></div>
            <div class="collate-form-inner-box3">
                <div class="collate-form-sub-menu dsp-flex">
                    <span class="collate-form-sub-menu-item item2 cur">输入时间</span>
                    <span class="collate-form-sub-menu-item item3" @click="clickAdvanced('sizhu')">四柱</span>
                </div>
            </div>
        </div>
        <div class="collate-form-box" @click="selectBirthday">
            <label class="collate-form-label cf-label-two">出生日期:</label>
            <div class="collate-form-note">
                <div v-if="selectedBirthday.length == 0">
                    <p>点击输入出生日期</p>
                    <i class="icon-right-arrow"></i>
                </div>
                <div class="collate-form-note-two" v-else>
                    <p v-for="(birth, key) in selectedBirthday" :class="{'collate-form-note-area' : (key == 0)}" v-bind:key="key">{{birth}}</p>
                </div>
            </div>
            <div class="cf-pos-right"><i class="cf-icon-right iconfont icon-xiangyou"></i></div>
        </div>
        <div class="collate-form-box" @click="selectArea">
            <label class="collate-form-label">出生地址:</label>
            <div class="collate-form-note">
                <div v-if="selectedArea.length == 0">
                    <p>选填, 根据出生地计算当地真太阳时间</p>
                </div>
                <div class="collate-form-note-two" v-bind:class="{'collate-form-note-two-one': selectedArea.length == 1}" v-else>
                    <p v-for="(area, key) in selectedArea" :class="{'collate-form-note-area' : (key == 0)}" v-bind:key="key">{{area}}</p>
                </div>
                <i class="icon-right-arrow"></i>
            </div>
            <div class="cf-pos-right"><i class="cf-icon-right iconfont icon-xiangyou"></i></div>
        </div>
        <!-- 档案分组+标签备注 -->
        <div class="collate-form-box">
            <label class="collate-form-label cf-label-two">档案分组:</label>
            <div class="collate-form-choose" @click="chooseGroup">
                <span v-if="choosedGroup.id > 0" class="cf-icon-text cf-icon-text2">{{choosedGroup.f_name.slice(0, 6)}}</span>
                <span v-else class="cf-icon-text cf-icon-text2">全部</span>
                <i class="cf-icon-right iconfont icon-xiangyou"></i>
            </div>
            
            <label class="collate-form-label cf-label-three">标签备注:<span class="cf-label-line"></span></label>
            <div class="collate-form-choose cf-pos-right" @click="chooseLabel">
                <span class="cf-icon-text cf-icon-text2">{{selectedLabelString.slice(0, 5)}}</span>
                <i class="cf-icon-right iconfont icon-xiangyou"></i>
            </div>
        </div>

        <!-- 编辑页:区分早晚子时 -->
        <div v-if="parentNode.name == 'EditDetail'">
            <div class="collate-form-box">
                <label class="collate-form-label cf-label-two">分早晚子时</label>
                <div class="collate-form-note">
                    <span class="collate-form-span">24点作为一天点开始</span>
                    <van-switch class="collate-form-switch" v-model="choosedZWZ" @change="changeZWZ" size="22px" active-color="#0d9700" inactive-color="#eee" />
                </div>
            </div>
            <div class="collate-form-box">
                <label class="collate-form-label cf-label-two">不分早晚子时</label>
                <div class="collate-form-note">
                    <span class="collate-form-span">23点作为一天点开始</span>
                    <van-switch class="collate-form-switch" v-model="choosedNZWZ" @change="changeNZWZ" size="22px" active-color="#0d9700" inactive-color="#eee" />
                </div>
            </div>
            <div class="collate-form-box">
                <label class="collate-form-label cf-label-two">使用真太阳时</label>
                <div class="collate-form-note">
                    <span class="collate-form-span">（即地方时间）</span>
                    <van-switch class="collate-form-switch" v-model="choosedRT" @change="changeRT" size="22px" active-color="#0d9700" inactive-color="#eee" />
                </div>
            </div>
            <div class="collate-form-box">
                <label class="collate-form-label cf-label-two">不使用真太阳时</label>
                <div class="collate-form-note">
                    <span class="collate-form-span">（忽略地方时间）</span>
                    <van-switch class="collate-form-switch" v-model="choosedNRT" @change="changeNRT" size="22px" active-color="#0d9700" inactive-color="#eee" />
                </div>
            </div>
        </div>
        <!-- 起盘页:提交按钮 -->
        <div v-else-if="parentNode.name == 'Collate'" class="collate-form-btn dsp-flex">
            <div class="collate-form-btn-side">
                <div class="button-report" @click="clickStart('report')"></div>
                <div v-if="!aitips" class="report-tips report-tips-1"></div>
            </div>
            <div class="collate-form-btn-main">
                <button class="button-start" @click="clickStart('collate')">专业排盘</button>
            </div>
            <div class="collate-form-btn-side">
                <!-- <div class="button-year" @click="clickStart('year')" :style="settingConfigData.year ? 'background-image: url('+settingConfigData.year+')' : ''"></div> -->
                <div class="button-year" @click="clickStart('year')"></div>
            </div>
        </div>
    </div>
</template>

<script>
import reminder from '../../modules/store/modules/reminder';
import { DOM } from '../../modules/dom'
import { MIX } from '../../modules/utils';
export default {
    name: 'CollateForm',
    props: ['parentNode', 'chooseGroupFunc', 'personData', 'chooseLabelFunc'],
    computed: {
        aiButtonClickedStatus() {
            return this.$store.state.reminder.aiButtonClickedStatus;
        },
        choosedGroup() {
            return this.$store.state.group.choosedGroup;
        },
        selectedLabelString() {
            return this.$store.state.label.selectedLabelString;
        },
        formData() {
            return this.$store.state.collate.formData;
        },
        selectedArea() {
            return this.$store.state.collate.selectedArea;
        },
        selectedBirthday() {
            return this.$store.state.collate.selectedBirthday;
        },
        aitips() {
            return this.$store.state.reminder.aitips;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
    },
    data(){
        return {
            choosedZWZ: false, choosedNZWZ: false,
            choosedRT: false, choosedNRT: false,
        }
    },
    mounted: function() {
        // 编辑命盘页:设置当前早晚子时状态
        if(this.personData){
            console.log('this.personData----', this.personData)
            this.choosedZWZ = this.personData.zwzs == 1 ? true : false;
            this.choosedNZWZ = this.personData.zwzs == 0 ? true : false;
            this.choosedRT = this.personData.rt == 0 ? true : false;
            this.choosedNRT = this.personData.rt == 1 ? true : false;
        }
    },
    methods:{
        chooseGroup() {
            MIX.trackButtonClicked('home_group');
            if(this.chooseGroupFunc && typeof(this.chooseGroupFunc) == 'function'){
                this.chooseGroupFunc();
            }
        },
        chooseLabel() {
            MIX.trackButtonClicked('home_label_remark');
            if(this.chooseLabelFunc && typeof(this.chooseLabelFunc) == 'function') {
                this.chooseLabelFunc();
            }
        },
        selectSex(index) {
            this.$store.state.collate.formData.sex = index;

            // 编辑页面要触发编辑页的命盘信息的更改
            if(this.parentNode.name == 'EditDetail'){
                this.$store.dispatch('edit/updateEditDetail', 'sex');
            }
        },
        selectArea() {
            this.$store.state.collate.showArea = true;
        },
        selectBirthday() {
            this.$store.state.collate.showBirthday = true;
            setTimeout(() => {
                this.$bus.emit('initIPBPKeyBoard');
            }, 100);
        },
        clickAdvanced(type) {
            if(type == 'sizhu') {
                MIX.trackButtonClicked('home_sizhu');
            }
            this.$store.dispatch('collate/initSizhuCollate');
            this.$router.replace('/collate/advancedcollate');
            DOM.hidePageByClassName('collate-page');
        },
        clickStart(type) {
            if(type == 'collate') {
                MIX.trackButtonClicked('home_qipan');
            }else if(type == 'report') {
                MIX.trackButtonClicked('home_ai');
            }else if(type == 'year') {
                MIX.trackButtonClicked('home_year');
            }
            // 检验数据
            if(this.formData.birthday == '' || typeof(this.formData.birthday) == 'number'){
                this.$toast("请填写生日");
                return;
            }
            // 处理姓名:可以空名起盘，生成命名取为"未命名"
            this.formData.f_name = this.formData.f_name == '' ? "未命名" : this.formData.f_name;
            // 处理分组:
            this.formData.f_group = this.choosedGroup.id;
            this.formData.f_group = !this.formData.f_group || this.formData.f_group == '' ? 0 : this.formData.f_group;
            // 处理性别:
            this.formData.sex = this.formData.sex == '' ? 0 : this.formData.sex;
            // 处理早晚子时:
            this.formData.zwzs = parseInt(this.settingConfigData.zaoWanZiShi);
            // 处理标签及备注信息
            this.formData.label = this.$store.state.label.selectedLabelId;
            this.formData.remark = this.$store.state.label.remarkStringData;

            console.log("起盘:::::", this.formData);
            
            var me = this;
            this.$store.state.collate.curStartCollateType = type;
            this.$store.dispatch('record/checkRecordListSameSiZhu', {
                formData: this.formData,
                cb: function() {
                    if(type == 'collate') {
                        me.$store.dispatch('collate/submitCollate', {
                            formData: me.formData,
                            cb: function(detailId) {
                                me.$router.replace('/detail/collate/'+ detailId);
                            }
                        });
                    }else if(type == 'report') {
                        me.$store.state.report.fromPage = 'collate';
                        me.$store.dispatch('collate/submitReport', {
                            formData: me.formData,
                            cb: function(detailId) {
                                me.$router.replace('/report/collate/'+ detailId);
                            }
                        });
                    }else if(type == 'year') {
                        console.log('年运起盘');
                        me.$store.dispatch('collate/submitYear', {
                            formData: me.formData,
                            cb: function(detailId) {
                                me.$router.replace('/yearcharacter/collate/'+ detailId);
                            }
                        });
                    }
                }
            });
        },
        blurInputName() {
            // 输入完成之后处理页面滚动
            if(this.parentNode.name == 'EditDetail'){
                var detailDiv = document.getElementsByClassName('edit-detail-content')[0];
                if(detailDiv){
                    detailDiv.scrollIntoView();
                }
            }
        },
        changeName() {
            if(this.parentNode.name == 'EditDetail'){
                MIX.trackButtonClicked('mingpan_name_edit');
                this.$store.dispatch('edit/updateEditDetail', 'name');
            }
        },
        changeZWZ(choosed) {
            this.choosedZWZ = choosed; this.choosedNZWZ = !choosed;
            this.personData.zwzs = choosed ? 1 : 0;
            if(this.parentNode.name == 'EditDetail'){
                this.$store.dispatch('edit/updateEditDetail', 'zwzs');
            }
        },
        changeNZWZ(choosed) {
            this.choosedZWZ = !choosed; this.choosedNZWZ = choosed;
            this.personData.zwzs = choosed ? 0 : 1;
            if(this.parentNode.name == 'EditDetail'){
                this.$store.dispatch('edit/updateEditDetail', 'zwzs');
            }
        },
        changeRT(choosed) {
            this.choosedRT = choosed; this.choosedNRT = !choosed;
            this.personData.rt = choosed ? 0 : 1;
            if(this.parentNode.name == 'EditDetail'){
                this.$store.dispatch('edit/updateEditDetail', 'rt');
            }
        },
        changeNRT(choosed) {
            this.choosedRT = !choosed; this.choosedNRT = choosed;
            this.personData.rt = choosed ? 1 : 0;
            if(this.parentNode.name == 'EditDetail'){
                this.$store.dispatch('edit/updateEditDetail', 'rt');
            }
        },
    }
}
</script>